module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._c;
  return _c('div', {
    staticClass: "container-fluid"
  }, [_c('bsf-layout', [_c('bsf-col', {
    attrs: {
      "size": "xs",
      "col": "12",
      "id": "rgroup"
    }
  }, [_c('div', [_c('bsf-doc', [_c('bsf-page-header', [_c('h3', {
    slot: "header"
  }, [_vm._v("\n\t\t\t\t\tGrid system 布局系统\n\t\t\t\t")])]), _vm._v(" "), _c('bsf-docmix', [_c('h4', {
    slot: "header"
  }, [_vm._v("\n\t\t\t\t\t一般布局\n\t\t\t\t")]), _vm._v(" "), _c('div', {
    slot: "info"
  }, [_c('p', [_vm._v("使用目前比较流行的bootstrap3.x 框架的12等分布局系统 size为适配的端（lg sm xs 默认情况下为md） col为尺寸 12等分")])]), _vm._v(" "), _c('div', {
    slot: "example"
  }, [_c('bsf-layout', [_vm._l((6), function(n) {
    return _c('bsf-col', {
      staticClass: "doc-col",
      attrs: {
        "size": "xs",
        "col": "2"
      }
    }, [_vm._v("col-*-2")])
  }), _vm._v(" "), _vm._l((4), function(n) {
    return _c('bsf-col', {
      staticClass: "doc-col",
      attrs: {
        "size": "xs",
        "col": "3"
      }
    }, [_vm._v("col-*-3")])
  }), _vm._v(" "), _vm._l((2), function(n) {
    return _c('bsf-col', {
      staticClass: "doc-col",
      attrs: {
        "size": "xs",
        "col": "6"
      }
    }, [_vm._v("col-*-1")])
  }), _vm._v(" "), _c('bsf-col', {
    staticClass: "doc-col",
    attrs: {
      "size": "xs",
      "col": "4"
    }
  }, [_vm._v("col-*-4")]), _vm._v(" "), _c('bsf-col', {
    staticClass: "doc-col",
    attrs: {
      "size": "xs",
      "col": "8"
    }
  }, [_vm._v("col-*-8")])], true)])]), _vm._v(" "), _c('bsf-docmix', [_c('h4', {
    slot: "header"
  }, [_vm._v("\n\t\t\t\t\t适配布局\n\t\t\t\t")]), _vm._v(" "), _c('div', {
    slot: "info"
  }, [_c('p', [_vm._v("自动适配各平台 使用bootstrap的css")])]), _vm._v(" "), _c('div', {
    slot: "example"
  }, [_c('bsf-layout', _vm._l((['lg', 'md', 'sm', 'xs']), function(size) {
    return _c('bsf-col', {
      staticClass: "doc-col",
      attrs: {
        "size": size,
        "col": "8"
      }
    }, [_vm._v("现在仅仅适配" + _vm._s(size) + "到mobile")])
  }))])]), _vm._v(" "), _c('bsf-docmix', [_c('h4', {
    slot: "header"
  }, [_vm._v("\n\t\t\t\t\tcol-*-* offset\n\t\t\t\t")]), _vm._v(" "), _c('div', {
    slot: "info"
  }, [_c('p', [_vm._v("col offset 设置")])]), _vm._v(" "), _c('div', {
    slot: "example"
  }, [_c('bsf-layout', [_c('bsf-col', {
    staticClass: "doc-col",
    attrs: {
      "size": "xs",
      "offset": "1",
      "col": "2"
    }
  }, [_vm._v("offset")])]), _vm._v(" "), _c('bsf-layout', [_c('bsf-col', {
    staticClass: "doc-col",
    attrs: {
      "size": "xs",
      "offset": "2",
      "col": "2"
    }
  }, [_vm._v("offset")])]), _vm._v(" "), _c('bsf-layout', [_c('bsf-col', {
    staticClass: "doc-col",
    attrs: {
      "size": "xs",
      "offset": "3",
      "col": "2"
    }
  }, [_vm._v("offset")])])])]), _vm._v(" "), _c('bsf-docmix', [_c('h4', {
    slot: "header"
  }, [_vm._v("\n\t\t\t\t\tcol-*-* push pull\n\t\t\t\t")]), _vm._v(" "), _c('div', {
    slot: "info"
  }, [_c('p', [_vm._v("col push pull 设置")])]), _vm._v(" "), _c('div', {
    slot: "example"
  }, [_c('bsf-layout', [_c('bsf-col', {
    staticClass: "doc-col",
    attrs: {
      "size": "xs",
      "push": "3",
      "col": "9"
    }
  }, [_vm._v("push3")]), _vm._v(" "), _c('bsf-col', {
    staticClass: "doc-col",
    attrs: {
      "size": "xs",
      "pull": "9",
      "col": "3"
    }
  }, [_vm._v("push9")])])])])]), _vm._v(" "), _c('bsf-doc', [_c('bsf-page-header', [_c('h3', {
    slot: "header"
  }, [_vm._v("\n\t\t\t\t\t表单元素 input\n\t\t\t\t")])]), _vm._v(" "), _c('bsf-docmix', [_c('h4', {
    slot: "header"
  }, [_vm._v("基础用法")]), _vm._v(" "), _c('div', {
    slot: "example"
  }, [_c('p', [_vm._v("placeholder：")]), _vm._v(" "), _c('bsf-input', {
    attrs: {
      "placeholder": "请输入内容"
    }
  }), _vm._v(" "), _c('p', [_vm._v("初始值：")]), _vm._v(" "), _c('bsf-input', {
    attrs: {
      "val": "1234"
    }
  }), _vm._v(" "), _c('p', [_vm._v("密码输入框：")]), _vm._v(" "), _c('bsf-input', {
    attrs: {
      "val": "123456789",
      "itype": "text",
      "psd": true
    }
  }), _vm._v(" "), _c('p', [_vm._v("textarea：")]), _vm._v(" "), _c('bsf-input', {
    attrs: {
      "row": "5",
      "itype": "textarea"
    }
  })])]), _vm._v(" "), _c('bsf-docmix', [_c('h4', {
    slot: "header"
  }, [_vm._v("禁用状态")]), _vm._v(" "), _c('div', {
    slot: "example"
  }, [_c('bsf-input', {
    attrs: {
      "disabled": true,
      "val": "默认的内容状态"
    }
  })])]), _vm._v(" "), _c('bsf-docmix', [_c('h4', {
    slot: "header"
  }, [_vm._v("尺寸")]), _vm._v(" "), _c('p', {
    slot: "info"
  }, [_vm._v("size ['lg','sm']")]), _vm._v(" "), _c('div', {
    slot: "example"
  }, [_c('bsf-input', {
    attrs: {
      "placeholder": "请输入内容",
      "val": "input size 正常"
    }
  }), _vm._v(" "), _vm._l((['lg', 'sm']), function(size) {
    return _c('bsf-input', {
      attrs: {
        "placeholder": "请输入内容",
        "size": size,
        "val": "input size lg sm"
      }
    })
  })], true)]), _vm._v(" "), _c('bsf-docmix', [_c('h4', {
    slot: "header"
  }, [_vm._v("带icon")]), _vm._v(" "), _c('div', {
    slot: "example"
  }, [_c('bsf-form-group', {
    attrs: {
      "icon": "home"
    }
  }, [_c('bsf-input')])])]), _vm._v(" "), _c('bsf-docmix', [_c('h4', {
    slot: "header"
  }, [_vm._v("带icon和状态的input")]), _vm._v(" "), _c('p', {
    slot: "info"
  }, [_vm._v("['success', 'warning', 'error']")]), _vm._v(" "), _c('div', {
    slot: "example"
  }, _vm._l((['success', 'warning', 'error']), function(s) {
    return _c('bsf-form-group', {
      attrs: {
        "icon": "home",
        "states": s
      }
    }, [_c('bsf-input')])
  }))]), _vm._v(" "), _c('bsf-docmix', [_c('h4', {
    slot: "header"
  }, [_vm._v("有label的input")]), _vm._v(" "), _c('div', {
    slot: "example"
  }, [_c('bsf-form-group', {
    attrs: {
      "label": "邮箱地址"
    }
  }, [_c('bsf-input', {
    attrs: {
      "placeholder": "请输入你的邮箱地址"
    }
  })])])]), _vm._v(" "), _c('bsf-docmix', [_c('h4', {
    slot: "header"
  }, [_vm._v("与label同行的input")]), _vm._v(" "), _c('p', {
    slot: "info"
  }, [_vm._v(" 需要bsf-form 设置inline")]), _vm._v(" "), _c('div', {
    slot: "example"
  }, [_c('bsf-form', {
    attrs: {
      "direction": "horizontal"
    }
  }, [_c('bsf-form-group', {
    attrs: {
      "label": "邮箱地址：",
      "csize": "xs",
      "col": "10"
    }
  }, [_c('bsf-input', {
    attrs: {
      "placeholder": "请输入你的邮箱地址"
    }
  })]), _vm._v(" "), _c('bsf-form-group', {
    attrs: {
      "label": "密码：",
      "csize": "xs",
      "col": "10"
    }
  }, [_c('bsf-input', {
    attrs: {
      "psd": true,
      "placeholder": "请输入你的密码"
    }
  })])]), _vm._v(" "), _c('bsf-form', {
    attrs: {
      "direction": "inline"
    }
  }, [_c('bsf-form-group', {
    attrs: {
      "label": "邮箱地址："
    }
  }, [_c('bsf-input', {
    attrs: {
      "placeholder": "请输入你的邮箱地址"
    }
  })]), _vm._v(" "), _c('bsf-form-group', {
    attrs: {
      "label": "密码"
    }
  }, [_c('bsf-input', {
    attrs: {
      "psd": true,
      "placeholder": "请输入你的用密码"
    }
  })])])])]), _vm._v(" "), _c('bsf-docmix', [_c('h4', {
    slot: "header"
  }, [_vm._v("form帮助提示信息")]), _vm._v(" "), _c('p', {
    slot: "info"
  }, [_vm._v("设置帮助信息")]), _vm._v(" "), _c('div', {
    slot: "example"
  }, [_c('bsf-form', {
    attrs: {
      "direction": "horizontal"
    }
  }, [_c('bsf-form-group', {
    attrs: {
      "label": "邮箱地址：",
      "csize": "xs",
      "col": "10",
      "help": "建议使用国内邮箱"
    }
  }, [_c('bsf-input', {
    attrs: {
      "placeholder": "请输入你的邮箱地址"
    }
  }), _vm._v(" "), _c('bsf-input')]), _vm._v(" "), _c('bsf-form-group', {
    attrs: {
      "label": "密码：",
      "csize": "xs",
      "col": "10",
      "help": "请勿向第三方泄露您的密码信息"
    }
  }, [_c('bsf-input', {
    attrs: {
      "psd": true,
      "placeholder": "请输入你的密码"
    }
  })])])])])]), _vm._v(" "), _c('bsf-doc', [_c('bsf-page-header', [_c('h3', {
    slot: "header"
  }, [_vm._v("表单元素Checkboxes and radios")])]), _vm._v(" "), _c('bsf-docmix', [_c('h4', {
    slot: "header"
  }, [_vm._v("一般用法")]), _vm._v(" "), _c('div', {
    slot: "example"
  }, [_c('bsf-checkbox', {
    attrs: {
      "label": "使用bsf-vue扩展",
      "name": "ck1"
    }
  }), _vm._v(" "), _c('bsf-checkbox', {
    attrs: {
      "label": "使用bsf-vue扩展",
      "name": "ck1"
    }
  }), _vm._v(" "), _c('bsf-checkbox', {
    attrs: {
      "disabled": true,
      "label": "使用bsf-css扩展",
      "name": "ck1"
    }
  }), _vm._v(" "), _c('hr'), _vm._v(" "), _c('bsf-radio', {
    attrs: {
      "label": "使用bsf-vue扩展",
      "name": "op1"
    }
  }), _vm._v(" "), _c('bsf-radio', {
    attrs: {
      "label": "",
      "name": "op1"
    }
  }), _vm._v(" "), _c('bsf-radio', {
    attrs: {
      "disabled": true,
      "label": "我不使用bsf-vue扩展",
      "name": "op1"
    }
  })])]), _vm._v(" "), _c('bsf-docmix', [_c('h4', {
    slot: "header"
  }, [_vm._v("inline")]), _vm._v(" "), _c('div', {
    slot: "example"
  }, [_c('bsf-checkbox', {
    attrs: {
      "inline": "",
      "label": "check1",
      "name": "ck2"
    }
  }), _vm._v(" "), _c('bsf-checkbox', {
    attrs: {
      "inline": "",
      "label": "check2",
      "name": "ck2"
    }
  }), _vm._v(" "), _c('bsf-checkbox', {
    attrs: {
      "inline": "",
      "label": "check3",
      "name": "ck2"
    }
  }), _vm._v(" "), _c('hr'), _vm._v(" "), _c('bsf-radio', {
    attrs: {
      "inline": "",
      "label": "radio1",
      "name": "op2"
    }
  }), _vm._v(" "), _c('bsf-radio', {
    attrs: {
      "inline": "",
      "label": "radio2",
      "name": "op2"
    }
  }), _vm._v(" "), _c('bsf-radio', {
    attrs: {
      "inline": "",
      "label": "radio3",
      "name": "op2"
    }
  })])])]), _vm._v(" "), _c('bsf-doc', [_c('bsf-page-header', [_c('h3', {
    slot: "header"
  }, [_vm._v("表单元素select")])]), _vm._v(" "), _c('bsf-docmix', [_c('p', {
    slot: "info"
  }, [_vm._v(":data 数据源;sname 展示内容,sval select value")]), _vm._v(" "), _c('div', {
    slot: "example"
  }, [_c('bsf-select', {
    attrs: {
      "data": _vm.selectDate,
      "sname": "name",
      "sval": "value"
    },
    on: {
      "selected": _vm.selected
    }
  }), _vm._v(" "), _c('bsf-select', {
    attrs: {
      "data": _vm.selectDate,
      "sname": "name",
      "sval": "value"
    },
    on: {
      "selected": _vm.selected
    }
  }), _vm._v(" "), _vm._v(" "), _c('bsf-input-group', {
    attrs: {
      "addon": "您选择了："
    }
  }, [_c('bsf-input', {
    attrs: {
      "placeholder": "请输入金额",
      "val": _vm.selmsg
    },
    slot: "input"
  })])])])]), _vm._v(" "), _c('bsf-doc', [_c('bsf-page-header', [_c('h3', {
    slot: "header"
  }, [_vm._v("Button 按钮")])]), _vm._v(" "), _c('bsf-docmix', [_c('h4', {
    slot: "header"
  }, [_vm._v("一般按钮")]), _vm._v(" "), _c('div', {
    slot: "info"
  }, [_c('p', [_vm._v("基础的按钮用法。")])]), _vm._v(" "), _c('div', {
    slot: "example"
  }, [_c('ul', {
    staticClass: "list-inline"
  }, [_vm._l((['default', 'primary', 'success', 'info', 'warning', 'danger', 'ces']), function(btn) {
    return _c('li', [_c('bsf-btn', {
      attrs: {
        "btype": btn
      }
    }, [_vm._v(_vm._s(btn))])])
  }), _vm._v(" "), _c('li', [_c('bsf-btn', {
    attrs: {
      "btype": "link"
    }
  }, [_vm._v("link")])])], true)])]), _vm._v(" "), _c('bsf-docmix', [_c('h4', {
    slot: "header"
  }, [_vm._v("unbg按钮")]), _vm._v(" "), _c('div', {
    slot: "info"
  }, [_c('p', [_vm._v("无背景按钮。")])]), _vm._v(" "), _c('div', {
    slot: "example"
  }, [_c('ul', {
    staticClass: "list-inline"
  }, _vm._l((['default', 'primary', 'success', 'info', 'warning', 'danger', 'ces']), function(btn) {
    return _c('li', [_c('bsf-btn', {
      attrs: {
        "unbg": true,
        "btype": btn
      }
    }, [_vm._v(_vm._s(btn))])])
  }))])]), _vm._v(" "), _c('bsf-docmix', [_c('h4', {
    slot: "header"
  }, [_vm._v("边框按钮")]), _vm._v(" "), _c('div', {
    slot: "info"
  }, [_c('p', [_vm._v("边框按钮。")])]), _vm._v(" "), _c('div', {
    slot: "example"
  }, [_c('ul', {
    staticClass: "list-inline"
  }, _vm._l((['default', 'primary', 'success', 'info', 'warning', 'danger', 'ces']), function(btn) {
    return _c('li', [_c('bsf-btn', {
      attrs: {
        "border": true,
        "btype": btn
      }
    }, [_vm._v(_vm._s(btn))])])
  }))])]), _vm._v(" "), _c('bsf-docmix', [_c('h4', {
    slot: "header"
  }, [_vm._v("按钮尺寸")]), _vm._v(" "), _c('div', {
    slot: "info"
  }, [_c('p', [_vm._v("不同尺寸的按钮。")])]), _vm._v(" "), _c('div', {
    slot: "example"
  }, [_c('ul', {
    staticClass: "list-inline"
  }, [_vm._l((['lg', 'sm', 'xs']), function(size) {
    return _c('li', [_c('bsf-btn', {
      attrs: {
        "btype": "ces",
        "size": size
      }
    }, [_vm._v(_vm._s(size) + "尺寸按钮")])])
  }), _vm._v(" "), _c('li', [_c('bsf-btn', [_vm._v("默认尺寸")])])], true), _vm._v(" "), _c('bsf-btn', {
    attrs: {
      "btype": "ces",
      "block": true
    }
  }, [_vm._v("block 按钮")])])]), _vm._v(" "), _c('bsf-docmix', [_c('h4', {
    slot: "header"
  }, [_vm._v("有icon的按钮")]), _vm._v(" "), _c('div', {
    slot: "info"
  }, [_c('p', [_vm._v("可以给按钮增加icon。")])]), _vm._v(" "), _c('div', {
    slot: "example"
  }, [_c('bsf-btn', {
    attrs: {
      "btype": "ces",
      "icon": "icon-home"
    }
  }), _vm._v(" "), _c('bsf-btn', {
    attrs: {
      "btype": "ces",
      "icon": "icon-home"
    }
  }, [_vm._v("按钮")]), _vm._v(" "), _c('bsf-btn', {
    attrs: {
      "btype": "ces",
      "icon": ['icon-home', 'right']
    }
  }, [_vm._v("按钮")])])]), _vm._v(" "), _c('bsf-docmix', [_c('h4', {
    slot: "header"
  }, [_vm._v("按钮状态控制")]), _vm._v(" "), _c('div', {
    slot: "info"
  }, [_c('p', [_vm._v("按钮禁用不能点击。")])]), _vm._v(" "), _c('div', {
    slot: "example"
  }, [_c('bsf-btn', {
    attrs: {
      "btype": "ces",
      "disabled": true,
      "border": true
    }
  }, [_vm._v("按钮")]), _vm._v(" "), _c('bsf-btn', {
    attrs: {
      "btype": "ces",
      "disabled": true,
      "unbg": true
    }
  }, [_vm._v("按钮")]), _vm._v(" "), _c('bsf-btn', {
    attrs: {
      "btype": "ces",
      "disabled": true
    }
  }, [_vm._v("按钮")])])])]), _vm._v(" "), _c('bsf-doc', [_c('bsf-page-header', [_c('h3', {
    slot: "header"
  }, [_vm._v("inputgroup")])]), _vm._v(" "), _c('bsf-docmix', [_c('h4', {
    slot: "header"
  }, [_vm._v("一般用法和样式")]), _vm._v(" "), _c('div', {
    slot: "example"
  }, [_c('bsf-input-group', {
    attrs: {
      "addon": ['$', '.00']
    }
  }, [_c('bsf-input', {
    attrs: {
      "placeholder": "请输入金额"
    },
    slot: "input"
  })]), _vm._v(" "), _c('bsf-input-group', {
    attrs: {
      "addon": "$"
    }
  }, [_c('bsf-input', {
    attrs: {
      "placeholder": "请输入金额"
    },
    slot: "input"
  })]), _vm._v(" "), _c('bsf-input-group', {
    attrs: {
      "addon": ".00",
      "right": true
    }
  }, [_c('bsf-input', {
    attrs: {
      "placeholder": "请输入金额"
    },
    slot: "input"
  })]), _vm._v(" "), _c('bsf-input-group', {
    attrs: {
      "addon": "https://example.com/users/"
    }
  }, [_c('bsf-input', {
    slot: "input"
  })])])]), _vm._v(" "), _c('bsf-docmix', [_c('h4', {
    slot: "header"
  }, [_vm._v("inputgroup 尺寸")]), _vm._v(" "), _c('div', {
    slot: "example"
  }, [_vm._l((['lg', 'sm']), function(size) {
    return _c('bsf-input-group', {
      attrs: {
        "addon": "$",
        "size": size
      }
    }, [_c('bsf-input', {
      attrs: {
        "val": [size] + '尺寸',
        "placeholder": "用户名称"
      },
      slot: "input"
    })])
  }), _vm._v(" "), _c('bsf-input-group', {
    attrs: {
      "addon": "$"
    }
  }, [_c('bsf-input', {
    attrs: {
      "val": "一般尺寸",
      "placeholder": "用户名称"
    },
    slot: "input"
  })])], true)]), _vm._v(" "), _c('bsf-docmix', [_c('h4', {
    slot: "header"
  }, [_vm._v("Table")]), _vm._v(" "), _c('div', {
    slot: "info"
  }, [_c('ol', [_c('li', [_vm._v("label 表头名称")]), _vm._v(" "), _c('li', [_vm._v("prop td 字段名")]), _vm._v(" "), _c('li', [_vm._v("data 数据")]), _vm._v(" "), _c('li', [_vm._v("[bordered,striped,hover,condensed] bs样式")])])]), _vm._v(" "), _c('div', {
    slot: "example"
  }, [_c('p', [_vm._v("默认样式")]), _vm._v(" "), _c('bsf-table', {
    attrs: {
      "data": _vm.tableData
    }
  }, [_c('e-column', {
    attrs: {
      "label": "名字",
      "prop": "name"
    }
  }), _vm._v(" "), _c('e-column', {
    attrs: {
      "label": "日期",
      "prop": "date"
    }
  }), _vm._v(" "), _c('e-column', {
    attrs: {
      "label": "地址",
      "prop": "address"
    }
  })]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('p', [_vm._v("border")]), _vm._v(" "), _c('bsf-table', {
    attrs: {
      "bordered": "",
      "data": _vm.tableData
    }
  }, [_c('e-column', {
    attrs: {
      "label": "名字",
      "prop": "name"
    }
  }), _vm._v(" "), _c('e-column', {
    attrs: {
      "label": "日期",
      "prop": "date"
    }
  }), _vm._v(" "), _c('e-column', {
    attrs: {
      "label": "地址",
      "prop": "address"
    }
  })]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('p', [_vm._v("striped")]), _vm._v(" "), _c('bsf-table', {
    attrs: {
      "striped": "",
      "data": _vm.tableData
    }
  }, [_c('e-column', {
    attrs: {
      "label": "名字",
      "prop": "name"
    }
  }), _vm._v(" "), _c('e-column', {
    attrs: {
      "label": "日期",
      "prop": "date"
    }
  }), _vm._v(" "), _c('e-column', {
    attrs: {
      "label": "地址",
      "prop": "address"
    }
  })]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('p', [_vm._v("hover")]), _vm._v(" "), _c('bsf-table', {
    attrs: {
      "hover": "",
      "data": _vm.tableData
    }
  }, [_c('e-column', {
    attrs: {
      "label": "名字",
      "prop": "name"
    }
  }), _vm._v(" "), _c('e-column', {
    attrs: {
      "label": "日期",
      "prop": "date"
    }
  }), _vm._v(" "), _c('e-column', {
    attrs: {
      "label": "地址",
      "prop": "address"
    }
  })]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('p', [_vm._v("condensed")]), _vm._v(" "), _c('bsf-table', {
    attrs: {
      "condensed": "",
      "data": _vm.tableData
    }
  }, [_c('e-column', {
    attrs: {
      "label": "名字",
      "prop": "name"
    }
  }), _vm._v(" "), _c('e-column', {
    attrs: {
      "label": "日期",
      "prop": "date"
    }
  }), _vm._v(" "), _c('e-column', {
    attrs: {
      "label": "地址",
      "prop": "address"
    }
  })])])])]), _vm._v(" "), _c('bsf-doc', [_c('bsf-page-header', [_c('h3', {
    slot: "header"
  }, [_vm._v("components 组件")])]), _vm._v(" "), _c('bsf-docmix', [_c('h4', {
    slot: "header"
  }, [_vm._v("Dropdowns & Button dropdowns")]), _vm._v(" "), _c('div', {
    slot: "info"
  }, [_c('ul', {
    staticClass: "list-unstyled"
  }, [_c('li', [_vm._v("1.data 数据源")]), _vm._v(" "), _c('li', [_vm._v("2.dptype dropdown方向")]), _vm._v(" "), _c('li', [_vm._v("3.dname dropdown的文字")]), _vm._v(" "), _c('li', [_vm._v("4.dval dropdown的数据")])])]), _vm._v(" "), _c('div', {
    slot: "example"
  }, [_c('bsf-dropdown', {
    attrs: {
      "data": _vm.dropdata,
      "up": true,
      "inline": true,
      "dname": "name",
      "dval": "value"
    },
    on: {
      "selected": _vm.dpselect
    }
  }), _vm._v(" "), _c('bsf-dropdown', {
    attrs: {
      "data": _vm.dropdata,
      "inline": true,
      "dname": "name",
      "dval": "value"
    },
    on: {
      "selected": _vm.dpselect
    }
  }), _vm._v(" "), _vm._l((['primary', 'success', 'info', 'warning', 'danger', 'ces']), function(type) {
    return _c('bsf-dropdown', {
      attrs: {
        "data": _vm.dropdata,
        "dname": "name",
        "dval": "value",
        "btype": type
      },
      on: {
        "selected": _vm.dpselect
      }
    })
  }), _vm._v(" "), _c('hr'), _vm._v(" "), _c('bsf-dropdown', {
    attrs: {
      "data": _vm.dropdata,
      "dname": "name",
      "inline": true,
      "dval": "value"
    },
    on: {
      "selected": _vm.dpselect
    }
  }), _vm._v(" "), _c('bsf-dropdown', {
    attrs: {
      "data": _vm.dropdata,
      "dname": "name",
      "up": true,
      "split": true,
      "btype": "danger",
      "dval": "value"
    },
    on: {
      "selected": _vm.dpselect
    }
  }), _vm._v(" "), _c('bsf-dropdown', {
    attrs: {
      "data": _vm.dropdata,
      "dname": "name",
      "split": true,
      "btype": "success",
      "dval": "value"
    },
    on: {
      "selected": _vm.dpselect
    }
  }), _vm._v(" "), _c('hr'), _vm._v(" "), _c('p', [_vm._v("尺寸 ['lg','sm','xs']")]), _vm._v(" "), _vm._l((['lg', 'sm', 'xs']), function(size) {
    return _c('bsf-dropdown', {
      attrs: {
        "data": _vm.dropdata,
        "bsize": size,
        "btype": "info",
        "dname": "name",
        "dval": "value"
      },
      on: {
        "selected": _vm.dpselect
      }
    })
  }), _vm._v(" "), _c('bsf-input-group', {
    attrs: {
      "addon": "您选择了"
    }
  }, [_c('bsf-input', {
    attrs: {
      "placeholder": "请输入金额",
      "val": _vm.dpval
    },
    slot: "input"
  })])], true)]), _vm._v(" "), _c('bsf-docmix', [_c('h4', {
    slot: "header"
  }, [_vm._v("Button groups")]), _vm._v(" "), _c('div', {
    slot: "info"
  }, [_c('p', [_vm._v("autofocus=\"true\" 默认focus")])]), _vm._v(" "), _c('div', {
    slot: "example"
  }, [_c('bsf-btn-group', [_c('bsf-btn', {
    attrs: {
      "btype": "ces",
      "autofocus": "true"
    }
  }, [_vm._v("按钮")]), _vm._v(" "), _c('bsf-btn', {
    attrs: {
      "btype": "ces"
    }
  }, [_vm._v("按钮")]), _vm._v(" "), _c('bsf-btn', {
    attrs: {
      "btype": "ces"
    }
  }, [_vm._v("按钮")])])])]), _vm._v(" "), _c('bsf-docmix', [_c('h4', {
    slot: "header"
  }, [_vm._v("Navs")]), _vm._v(" "), _c('div', {
    slot: "info"
  }, [_c('p', [_vm._v("[tabs,pills]")])]), _vm._v(" "), _c('div', {
    slot: "example"
  }, [_c('bsf-nav', {
    attrs: {
      "data": _vm.navdata,
      "btype": "tabs"
    }
  }), _vm._v(" "), _c('bsf-nav', {
    attrs: {
      "data": _vm.navdata,
      "btype": "pills"
    }
  }), _vm._v(" "), _c('bsf-nav', {
    attrs: {
      "data": _vm.navdata,
      "jfd": true,
      "btype": "tabs"
    }
  }), _vm._v(" "), _c('bsf-nav', {
    attrs: {
      "data": _vm.navdata,
      "btype": "pills",
      "jfd": true
    }
  })])]), _vm._v(" "), _c('bsf-docmix', [_c('h4', {
    slot: "header"
  }, [_vm._v("Navbar")]), _vm._v(" "), _c('div', {
    slot: "info"
  }, [_c('p', [_vm._v("navbar")])]), _vm._v(" "), _c('div', {
    slot: "example"
  }, [_c('p', [_vm._v("普通的navbar 普通的用")]), _vm._v(" "), _c('bsf-navbar'), _vm._v(" "), _c('p', [_vm._v("inverse效果")]), _vm._v(" "), _c('bsf-navbar', {
    attrs: {
      "inverse": ""
    }
  }), _vm._v(" "), _c('p', [_vm._v("logo")]), _vm._v(" "), _c('bsf-navbar', {
    attrs: {
      "name": "logo"
    }
  }), _vm._v(" "), _c('p', [_vm._v("Brand image")]), _vm._v(" "), _c('bsf-navbar', {
    attrs: {
      "name": "logo",
      "logo": _vm.bslogo
    }
  }), _vm._v(" "), _c('p', [_vm._v("form")]), _vm._v(" "), _c('bsf-navbar', {
    attrs: {
      "logo": _vm.bslogo
    }
  }, [_c('bsf-form', {
    staticClass: "navbar-form navbar-left",
    slot: "form"
  }, [_c('bsf-form-group', [_c('bsf-input')]), _vm._v(" "), _c('bsf-btn', {
    attrs: {
      "type": "submit"
    }
  }, [_vm._v("提交")])])]), _vm._v(" "), _c('p', [_vm._v("Button，text，link")]), _vm._v(" "), _c('bsf-navbar', {
    attrs: {
      "logo": _vm.bslogo
    }
  }, [_c('p', {
    staticClass: "navbar-right"
  }, [_c('bsf-btn', {
    staticClass: "navbar-btn"
  }, [_vm._v("登录")]), _vm._v(" "), _c('bsf-btn', {
    staticClass: "navbar-btn",
    attrs: {
      "btype": "ces"
    }
  }, [_vm._v("注册")])]), _vm._v(" "), _c('p', {
    staticClass: "navbar-text"
  }, [_vm._v("Signed in as\n\t\t\t\t\t\t\t\t\t"), _c('a', {
    staticClass: "navbar-link",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Mark Otto")])])]), _vm._v(" "), _c('bsf-navbar', {
    attrs: {
      "logo": _vm.bslogo
    }
  }, [_c('bsf-nav', {
    staticClass: "navbar-nav",
    attrs: {
      "data": _vm.navdata
    }
  })])])]), _vm._v(" "), _c('bsf-docmix', [_c('h4', {
    slot: "header"
  }, [_vm._v("Breadcrumbs")]), _vm._v(" "), _c('div', {
    slot: "info"
  }), _vm._v(" "), _c('div', {
    slot: "example"
  }, [_c('bsf-breadcrumb', {
    attrs: {
      "data": _vm.navdata1,
      "arrow": true
    }
  }), _vm._v(" "), _c('bsf-breadcrumb', {
    attrs: {
      "data": _vm.navdata1
    }
  })])]), _vm._v(" "), _c('bsf-docmix', [_c('h4', {
    slot: "header"
  }, [_vm._v("Pagination")]), _vm._v(" "), _c('p', {
    slot: "info"
  }, [_vm._v(" ['lg','sm']")]), _vm._v(" "), _c('div', {
    slot: "example"
  }, [_c('bsf-pagination', {
    attrs: {
      "total": 100
    }
  }), _vm._v(" "), _vm._l((['lg', 'sm']), function(size) {
    return _c('bsf-pagination', {
      attrs: {
        "total": 100,
        "psize": [size]
      }
    })
  })], true)]), _vm._v(" "), _c('bsf-docmix', [_c('h4', {
    slot: "header"
  }, [_vm._v("label")]), _vm._v(" "), _c('p', {
    slot: "info"
  }, [_vm._v("type in ['default', 'primary', 'success', 'info', 'warning', 'danger'],close [true,false]")]), _vm._v(" "), _c('div', {
    slot: "example"
  }, [_vm._l((['default', 'primary', 'success', 'info', 'warning', 'danger']), function(type) {
    return _c('bsf-label', {
      attrs: {
        "type": type
      }
    }, [_vm._v("标签")])
  }), _vm._v(" "), _c('hr'), _vm._v(" "), _vm._l((_vm.tags), function(tag, index) {
    return _c('bsf-label', {
      attrs: {
        "type": tag.type,
        "close": true
      },
      on: {
        "close": function($event) {
          _vm.closeLabel(tag)
        }
      }
    }, [_vm._v(_vm._s(tag.name))])
  })], true)]), _vm._v(" "), _c('bsf-docmix', [_c('h4', {
    slot: "header"
  }, [_vm._v("Badges")]), _vm._v(" "), _c('div', {
    slot: "example"
  }, [_c('bsf-btn', [_vm._v("服务信息\n\t\t\t\t\t\t\t\t"), _c('bsf-badges', {
    attrs: {
      "val": "15"
    }
  })]), _vm._v(" "), _c('bsf-btn', [_vm._v("服务信息\n\t\t\t\t\t\t\t\t"), _c('bsf-badges', {
    attrs: {
      "max": 10,
      "val": 11,
      "up": "",
      "imp": ""
    }
  })]), _vm._v(" "), _c('bsf-btn', [_vm._v("服务信息\n\t\t\t\t\t\t\t\t"), _c('bsf-badges', {
    attrs: {
      "val": "new",
      "up": ""
    }
  })]), _vm._v(" "), _c('bsf-btn', [_vm._v("服务信息\n\t\t\t\t\t\t\t\t"), _c('bsf-badges', {
    attrs: {
      "val": "new",
      "up": "",
      "imp": ""
    }
  })])])]), _vm._v(" "), _c('bsf-docmix', [_c('h4', {
    slot: "header"
  }, [_vm._v("Alert")]), _vm._v(" "), _c('div', {
    slot: "example"
  }, [_c('bsf-alert', {
    attrs: {
      "content": "你的服务器需要在近期续费"
    }
  }), _vm._v(" "), _vm._l((_vm.alertData), function(alert) {
    return _c('bsf-alert', {
      attrs: {
        "type": alert.type,
        "position": alert.position,
        "content": alert.content,
        "close": ""
      },
      on: {
        "close": function($event) {
          _vm.closeAlert(alert)
        }
      }
    })
  })], true)]), _vm._v(" "), _c('bsf-docmix', [_c('h4', {
    slot: "header"
  }, [_vm._v("Progress")]), _vm._v(" "), _c('div', {
    slot: "example"
  }, [_c('bsf-progress', {
    attrs: {
      "state": 70
    }
  }), _vm._v(" "), _c('bsf-progress', {
    attrs: {
      "state": 80,
      "end": true
    }
  }), _vm._v(" "), _c('hr'), _vm._v(" "), _vm._l((['success', 'info', 'warning', 'danger']), function(type) {
    return _c('bsf-progress', {
      attrs: {
        "type": type,
        "state": 40,
        "end": true
      }
    })
  }), _vm._v(" "), _c('hr'), _vm._v(" "), _c('bsf-progress', {
    attrs: {
      "state": 70,
      "end": true,
      "striped": true
    }
  }), _vm._v(" "), _c('bsf-progress', {
    attrs: {
      "state": 70,
      "end": true,
      "type": "success",
      "striped": "",
      "animate": ""
    }
  })], true)]), _vm._v(" "), _c('bsf-docmix', [_c('h4', {
    slot: "header"
  }, [_vm._v("Modal")]), _vm._v(" "), _c('p', {
    slot: "info"
  }, [_vm._v("modal尺寸size:[lg,sm,full]")]), _vm._v(" "), _c('div', {
    slot: "example"
  }, [_c('bsf-btn', {
    on: {
      "click": function($event) {
        _vm.modalshow2 = true
      }
    }
  }, [_vm._v("显示Modal")]), _vm._v(" "), _c('bsf-modal', {
    attrs: {
      "show": _vm.modalshow2,
      "header": "modal标题"
    },
    on: {
      "close": function($event) {
        _vm.modalshow2 = false
      }
    }
  }), _vm._v(" "), _c('bsf-btn', {
    on: {
      "click": function($event) {
        _vm.modalshow3 = true
      }
    }
  }, [_vm._v("显示Modalsm")]), _vm._v(" "), _c('bsf-modal', {
    attrs: {
      "show": _vm.modalshow3,
      "size": "sm"
    },
    on: {
      "close": function($event) {
        _vm.modalshow3 = false
      }
    }
  }), _vm._v(" "), _c('bsf-btn', {
    on: {
      "click": function($event) {
        _vm.modalshow = true
      }
    }
  }, [_vm._v("显示Modal lg")]), _vm._v(" "), _c('bsf-modal', {
    attrs: {
      "show": _vm.modalshow,
      "size": "lg"
    },
    on: {
      "close": function($event) {
        _vm.modalshow = false
      }
    }
  }), _vm._v(" "), _c('bsf-btn', {
    on: {
      "click": function($event) {
        _vm.modalshow1 = true
      }
    }
  }, [_vm._v("显示Modal full")]), _vm._v(" "), _c('bsf-modal', {
    attrs: {
      "show": _vm.modalshow1,
      "size": "full"
    },
    on: {
      "close": function($event) {
        _vm.modalshow1 = false
      }
    }
  })])]), _vm._v(" "), _c('bsf-docmix', [_c('h4', {
    slot: "header"
  }, [_vm._v("sideMenu")]), _vm._v(" "), _c('p', {
    slot: "info"
  }, [_vm._v("左侧边导航")]), _vm._v(" "), _c('div', {
    slot: "example"
  }, [_c('bsf-layout', [_c('bsf-col', {
    attrs: {
      "size": "xs",
      "col": "3",
      "id": "lgroup"
    }
  }, [_c('bsf-smenu', [_c('bsf-smenuli', {
    attrs: {
      "icon": "home",
      "label": "导航名称"
    }
  }, [_c('bsf-smenu', {
    slot: "menu"
  }, [_c('bsf-smenuli', {
    attrs: {
      "label": "二级导航"
    }
  })])]), _vm._v(" "), _c('bsf-smenuli', {
    attrs: {
      "icon": "user",
      "label": "导航名称"
    }
  }), _vm._v(" "), _c('bsf-smenuli', {
    attrs: {
      "icon": "home",
      "label": "导航名称"
    }
  }, [_c('bsf-label', {
    attrs: {
      "type": "warning"
    },
    slot: "label"
  }, [_vm._v("16/24")])]), _vm._v(" "), _c('bsf-smenuli', {
    attrs: {
      "icon": "sms",
      "label": "导航名称"
    }
  }, [_c('bsf-badges', {
    attrs: {
      "max": 10,
      "val": 11,
      "imp": ""
    },
    slot: "label"
  })]), _vm._v(" "), _c('bsf-smenuli', {
    attrs: {
      "icon": "shezhi",
      "label": "导航名称"
    }
  }, [_c('bsf-smenu', {
    slot: "menu"
  }, [_c('bsf-smenuli', {
    attrs: {
      "label": "二级导航"
    }
  }), _vm._v(" "), _c('bsf-smenuli', {
    attrs: {
      "label": "二级导航"
    }
  }), _vm._v(" "), _c('bsf-smenuli', {
    attrs: {
      "label": "二级导航"
    }
  }), _vm._v(" "), _c('bsf-smenuli', {
    attrs: {
      "label": "二级导航"
    }
  })])])])])])])])])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/.10.0.2@vue-loader/lib/template-compiler.js?id=data-v-6b243af6!./~/.10.0.2@vue-loader/lib/selector.js?type=template&index=0!./src/components/warp.vue
// module id = 322
// module chunks = 2